module.exports = __webpack_public_path__ + "static/media/data-protection-4394633_1920.624903f3.jpg";